module.exports = __webpack_public_path__ + "static/media/logooo.dd8e846d.png";